import React from 'react';
import { css } from '@emotion/css';
import SettingsCard from '../../../components/structure/SettingsCard';
import { useResponseVariableTester } from '../../../hooks/useResponseVariableTester';
import ResponseVariableTesterUI from '../../../components/general/ResponseVariableTesterUI';

const DOCS_URL = 'https://dev.azure.com/voicify/Voicify-Api/_wiki/wikis/Voicify-Api.wiki/39/Response-Variables?anchor=nesting-and-combining-features';

interface ResponseVariableTestSettingsProps {
    organizationId: string;
}

const ResponseVariableTestSettings: React.FC<ResponseVariableTestSettingsProps> = (props) => {
    const tester = useResponseVariableTester({ debounceMs: 750 });

    if (!props.organizationId) {
        return (
            <SettingsCard title="Response Variable Testing">
                <div className={containerStyle}>
                    <p>No organization selected.</p>
                </div>
            </SettingsCard>
        );
    }

    return (
        <SettingsCard title="Response Variable Testing" subtitle="Test response variable replacement with custom values">
            <div className={containerStyle}>
                <ResponseVariableTesterUI
                    {...tester}
                    docsUrl={DOCS_URL}
                    placeholder="Hello {{session.name}}, your order total is {{constant.currency}}{{session.order.total}}. Your loyalty level is {{user.tier}}."
                />
            </div>
        </SettingsCard>
    );
};

const containerStyle = css`
    padding: 8px;
`;

export default ResponseVariableTestSettings;
